export interface FingerprintProFields {
  fingerprint_request_id?: string;
  fingerprint_visitor_id?: string;
}

type FingerprintProCollector = () => Promise<FingerprintProFields>;

let collector: FingerprintProCollector | null = null;
let cachedFields: FingerprintProFields | null = null;

export const setFingerprintProCollector = (next: FingerprintProCollector | null): void => {
  collector = next;
};

export const clearFingerprintProCache = (): void => {
  cachedFields = null;
};

/**
 * Collects Fingerprint Pro event/visitor ids for application create & pending.
 * Results are cached so autosave does not burn identification quota on every draft.
 * Failures are swallowed — application submit must never be blocked.
 */
export const collectFingerprintProFields = async (): Promise<FingerprintProFields> => {
  if (cachedFields?.fingerprint_request_id) {
    return cachedFields;
  }

  if (!collector) {
    return {};
  }

  try {
    const fields = await collector();
    if (fields.fingerprint_request_id) {
      cachedFields = fields;
    }
    return fields;
  } catch (error) {
    console.error('Fingerprint Pro identification failed', error);
    return {};
  }
};
